import { Texture } from "three";
export function evictMaterial(v) {
    for (const _value of Object.values(v)) {
        const value = _value;
        if (value instanceof Texture) {
            value.dispose();
        }
    }
    v.dispose();
}
